import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import about from "../../img/icon-about.png"

const AboutSection = () => {
  const aboutRef = useRef(null);
  const [aboutInView, setAboutInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (aboutRef.current) {
        const rect = aboutRef.current.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          setAboutInView(true);
        } else {
          setAboutInView(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="about-us" className="py-5">
      <motion.div
        ref={aboutRef}
        initial={{ opacity: 0, y: 50 }}
        animate={aboutInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1 }}
        className="container"
      >
        <div className="row">
          <div className="col-12 text-center pb-3">
            <h2>
              <strong>About Us</strong>
            </h2>
          </div>

          <div className="col-12 text-center mb-4">
            <p>
              Cassava Supper adalah sebuah platform aplikasi yang memiliki fokus
              pada pengelolaan rantai pasok yang mencakup pasokan singkong,
              transportasi, pemrosesan utama dan lebih lanjut berbasis konsep
              Blockchain.
            </p>
          </div>
        </div>

        <div className="row align-items-center">
          <motion.div
            className="col-md-6 mb-4 mb-md-0 position-relative"
            initial={{ x: -100, opacity: 0 }}
            animate={aboutInView ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 1 }}
          >
            <img src={about} alt="About Cassava" className="img-fluid" />
            <div id="about-text" className="mt-3">
              <p className="fw-bold">OUR STORY</p>
              <h3>
                <b>
                  Something
                  <br />
                  Now
                  <br />
                  About
                  <br />
                  Us.
                </b>
              </h3>
            </div>
          </motion.div>

          <motion.div
            className="col-md-6"
            initial={{ x: 100, opacity: 0 }}
            animate={aboutInView ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 1 }}
          >
            <h2><strong>Information</strong></h2>
            <div id="description-info" style={{ textAlign: "justify" }}>
              <p>
                Cassava Super dibuat karena keresahan masyarakat karena sulitnya
                mendata proses transfer komoditas singkong, dari hulu hingga
                hilir. Maka terciptalah Cassava sebagai solusi untuk membangun
                sistem ketelusuran produk singkong yang berkelanjutan serta
                untuk meningkatkan efektivitas proses transfer komoditas
                singkong yang dapat dikembangkan secara Real-Time.
              </p>
              <p>
                <IoCheckmarkDoneCircleOutline className="icon me-2 " />
                Visibilitas dalam transfer bahan pasokan <br />
                <IoCheckmarkDoneCircleOutline className="icon me-2 " />
                Transparansi dalam hasil produksi singkong <br />
                <IoCheckmarkDoneCircleOutline className="icon me-2 " />
                Traceability dalam menelusuri produksi singkong anda
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default AboutSection;
